/* eslint-disable no-param-reassign */
export default {
    name: 'English',
    emoji: {
        key: 'en',
    },
    punctuation: {
        separator: ',',
    },
    time: {
        seconds: 'seconds',
        minutes: 'minutes',
        yesterday: 'Yesterday',
        morning: 'Morning',
        forenoon: 'Forenoon',
        noon: 'Noon',
        afternoon: 'Afternoon',
        evening: 'Evening',
        week: ['Sun.', 'Mon.', 'Tues.', 'Wed.', 'Thur.', 'Fri.', 'Sat.'],
        format: 'll',
    },
    tips: {
        loading: 'Loading...',
        inputText: 'Please input text...',
        searching: 'Searching...',
        searchEmpty: 'No more {{0}} related results',
        msgboxTitle: 'Hint',
        msgboxSubmitText: 'Confirm',
        departmentGroup: 'Dept.',
        companyGroup: 'Co.,Ltd.',
        allMemberGroup: 'All',
        contain: 'Include: ',
        fileUnexist: 'File does not exist',
        uploadAvatar: 'The picture is being uploaded',
        groupDismissed: 'The group has been dismissed',
        pwdTip: '6-16 numbers and letters.',
        publish: 'Publish',
        clearApprove: 'Confirm to clear group join request list ? ',
        zeroSize: 'Can not send a file with a size of 0',
        overSize: 'file to be sent cannot exceed {{0}}',
        recalled: 'Message recalled',
        mostMembers: 'You can choose up to {{0}} people',
        noMoreInfo: 'No more results, Please Check Your Network',
        tipUpdateVersion: 'A new client version was detected. Download it?',
        tipForceUpdate: 'The current version is no longer available, please download the new version!',
        downloadAndExit: 'Download and exit',
    },
    btns: {
        refresh: 'Refresh',
        transfer: 'transfer',
        edit: 'Edit',
        send: 'Send',
        startConversation: 'Send Messages',
        save: 'Save',
        saveAs: 'Save as',
        full: 'FullScreen',
        normal: 'Exit',
        prev: 'Previous',
        next: 'Next',
        prevPage: 'PreviousPage',
        nextPage: 'NextPage',
        reg: 'Sign Up',
        login: 'Login',
        logining: 'Logining...',
        logout: 'Log Out',
        rememberMe: 'Automatic Login',
        forget: 'Forgot Password',
        remove: 'Delete',
        removeConversation: 'Delete Conversation',
        cancel: 'Cancel',
        close: 'Close',
        confirm: 'Confirm',
        back: 'Back',
        collapse: 'PackUp',
        more: 'View All',
        checkedAll: 'Select All',
        clear: 'Clear',
        search: 'Search',
        searchPerson: 'Search Name, Mobile, Email',
        searchDuty: 'Search Position',
        searchOrg: 'Search Organization',
        expand: 'Expand',
        recall: 'Recall',
        copy: 'Copy',
        forward: 'Forward',
        untop: 'Remove from Top',
        top: 'Sticky on Top',
        mute: 'Mute Notifications',
        unmute: 'Receive new notifications',
        draft: 'Draft',
        saveContact: 'Save to Contacts',
        add: 'Add',
        inferior: 'Sub',
        zoomOut: 'Zoom Out',
        zoomIn: 'Zoom In',
        selectFile: 'Upload',
        groupChat: 'Group Chat',
        addFriend: 'Add Friends',
        createGroup: 'Create New Group',
        maximize: 'Maximize',
        minimize: 'Minimize',
        restore: 'Restore',
        download: 'Download',
        view: 'View',
        removeQuit: 'Delete and Exit',
        newPin: 'New PIN',
        confirmReply: 'Confirm and reply',
        publish: 'Publish',
        upgrade: 'Update now',
        saveToLocal: 'Save',
        quote: 'Quote',
        resumeUpload: 'Resume upload',
        resumDownload: 'Resume download',
    },
    contact: {
        department: 'Department',
        subcompany: 'Subcompany',
        contact: 'Contact',
        group: 'Group Chat',
        app: 'Application',
        orgContact: 'Organization',
        addressList: 'Organization Contacts',
        star: 'Star',
        friend: 'My Friends',
        recent: 'Recent Chats',
        selectedMember: 'Selected Member({{0}})',
        emptyMember: 'Select Contacts you want to add',
        expandDept: 'Subordinate',
        person: '{{0}} Members',
        personSingle: '{{0}} Member',
        myGroup: 'My Groups',
    },
    conversation: {
        draft: 'Draft',
        mute: 'Mute Notification',
        atme: 'You were mentioned',
        messageSentFail: 'Sent failed',
        empty: 'No Chat',
    },
    message: {
        requestFriendVerification:
            "You're not his（her）friend, Please send the friend verification request first. when request passes, You can chat.",
        requestFriendVerificationButton: 'Send the friend verification request',
        readAll: 'Read All',
        unknown: "The current version doesn't support for the message",
        read: 'Read',
        unread: 'Unread',
        checkUnread: 'View Unread',
        allRead: 'All Read',
        unreadMember: '{{0}} Unread',
        unreadMessageCount: '{{0}} Unread Messages',
        // 以下为群信息提示
        self: 'You',
        create: '{{0}} created the group',
        created: '{{0}} created the group',
        join: '{{0}} join the group',
        joinByQRCode:
            'Join the group chat via {{0}} Scanning shared QR Code {{1}}',
        invite: '{{0}} invited {{1}} to join the group',
        invited: '{{0}} invited {{1}} to join the group',
        inviteMe: '{{0}} invited you to join the group',
        kick: '{{0}} removed {{1}} from the group',
        kicked: '{{1}} were removed from the group by {{0}}',
        rename: '{{0}} changed the group name to "{{2}}"',
        renamed: '{{0}} changed the group name to "{{2}}"',
        quit: '{{0}} quitted the group',
        dismiss: 'Group has been disbanded',
        notice: '{{0}} clear notice',
        noticeTitle: 'Notice',
        OpenMute: 'The admin has enabled all-member silence',
        CloseMute: 'The admin has disabled all-member silence',
        addMute: '{{1}} has been silenced by admin',
        removeMute: '{{1}} has been released to speak by admin',
        updateManager: '{{1}} has become new admin',
        updateManagerSelf: '{{1}} has become new admin',
        unSupport: '不支持操作类型',
        // 以下为部门群信息提示
        createDepartment: 'Welcome to join {{2}}',
        joinDepartment: 'Welcome {{1}} join {{2}}',
        joinDepartmentSelf: 'Welcome to join {{2}}',
        departmentInvite: 'Welcome {{1}} join {{2}}',
        departmentInviteSelf: 'Welcome to join {{2}}',
        KickDepartment: '{{1}} was removed from the group',
        KickedDepartment: 'You were removed from the group',
        dismissDepartment: 'Group has been disbanded',
        renameDepartment: 'The group name has been changed to {{2}}',
        updateDepartmentManager: '{{1}} has become new admin',
        updateDepartmentManagerSelf: '{{1}} have become new admin',
        // 以下位好友验证通过后,聊天页面的提示信息
        passed: "{{0}} has accepted your friend request. Now let's chat!",
        pass: "You have accepted {{0}}'s friend request. Now start chat!",
        recallSelf: 'You have recalled a message',
        recallOther: '{{0}} has recalled a message',
        recallAdmin: 'Admin has recalled a message',
        cardSelf: 'You shared {{0}}',
        cardOther: 'Shared {{0}}',
        redPacketSent: 'Red packet has been sent. View on phone',
        redPacketReceived: 'Red packet received. View on phone',
        redPacketOpened: '{{0}} opened your Red Packet',
        youOpenedRedpack: "You've opened the Red Packet of {{0}}",
        youOpenedRedpackOfYouSent: "You've opened the Red Packet you sent",
        prefix: {
            ImageMessage: '[Photo]',
            GIFImageMessage: '[Photo]',
            LocalImageMessage: '[Photo]',
            VoiceMessage: '[Audio]',
            LocationMessage: '[Location]',
            FileMessage: '[File]',
            LocalFileMessage: '[File]',
            SightMessage: '[Video]',
            RichContentMessage: '[Link]',
            AudioMessage: '[Audio Call]',
            VideoMessage: '[Voice Call]',
            ShareScreenMessage: '[Share Screen]',
            ApprovalMessage: '[Approval]',
        },
        recallEdit: 'Edit',
    },
    user: {
        mobile: 'Cel.',
        staffNo: 'Staff NO.',
        signTel: 'Phone Number',
        tel: 'Phone',
        email: 'Email',
        deptName: 'Dept.',
        dutyName: 'Position',
        supervisorName: 'Superior',
        password: 'Password',
        nickName: 'Name',
        account: 'Account',
    },
    pin: {
        send: 'Sent',
        receive: 'Received',
    },
    updater: {
        status: {
            prepared: 'New Version Update',
            finished: 'You have the latest version',
            failed: 'Update failed',
            failedResult: 'Upgrade failed，please click "Update now" to retry',
        },
        updateProcess: {
            downloading:
                'Download the update package, please be patient（ {{0}}% ）',
            updating: 'Install updates（ {{0}}% ）',
            finished: 'Installation is complete',
        },
    },
    emptyMessage: {
        pin: 'No Pin message',
        star: 'No star contact',
        newFriend: 'No friends request',
        friend: 'No friends',
        group: 'No group',
        conversation: 'No conversation',
        approve: 'No join group request currently',
    },
    voip: {
        shareScreen: 'Share screen',
        audio: 'Audio Call',
        video: 'Voice Call',
        unAccept: 'Missed',
        end: 'Ended',
        audioTip: 'Audio call is on. Try again later.',
        videoTip: 'Voice call is on. Try again later.',
        shareScreenTip: 'Share screen is on. Try again later.',
        summaryCodeMap: {
            1: 'Cancelled',
            2: 'Declined',
            3: 'Duration ',
            4: 'Busy line',
            5: 'No answer',
            6: 'Not support the engine',
            7: 'Network Error',
            8: 'Has been handled by other end',
            11: 'Cancelled',
            12: 'Declined',
            13: 'Duration ',
            14: 'Busy line',
            15: 'No answer',
            16: 'Not support the engine',
            17: 'Network Error',
            18: 'voip unavailable',
        },
    },
    components: {
        appversion: {
            title: 'Features',
            show: 'Show',
        },
        getFileHelper: {
            title: 'File Assistant',
            desc: 'You can tranfer files、texts between your phone and PC',
            prompt: 'You can tranfer files，texts between your phone and PC',
            start: 'Send Message',
        },
        groupTransfer: {
            title: 'Select New Group Owner',
            message:
                'Are you sure to select {{0}} as new group owner, you will release your ownership?',
        },
        groupBanned: {
            title: 'Select Contacts',
            bannedAll: 'Mute All',
            silenterMembers: 'Muted Members',
            speakerMembers: 'Unmuted Members',
            banned: 'You have been muted',
        },
        signup: {
            title: 'Sign Up',
            nickNameTip: 'Please input name',
            mobileEmptyTip: 'Please input phone number',
            mobileErrTip: 'The phone nunber is illegal, please input again',
            captchaTip: 'Please input verification code ',
            captcha: 'Verification Code',
            pwdTip: 'Please input password',
            pwdLenTip:
                'Password contain numbers, letters, length 6-16 bits, case sensitive',
            pwdHasSpace: 'Please enter a password without spaces',
            sendCaptcha: 'Get code',
            // 界面布局原因这里使用英文括号比较合适
            sentCaptcha: 'Sent ({{0}})',
        },
        login: {
            scanLogin: 'QR code',
            pwdLogin: 'Password',
            QRCodeExpired: 'The QR code is invalid，',
            refreshTip: 'please refresh to get new QR code',
            scanTip: 'Please use QR code to log in',
            refresh: 'Refresh',
            mobileEmptyTip: 'Please input phone number',
            mobileErrTip: 'The phone nunber is illegal, please input again',
            account: 'Enter Account',
            inputPwd: 'Enter Password',
            accountEmptyTip: 'Please input Phone Number',
            noPwdTip: 'Please input password',
            autoLogin: 'Automatic login',
            forgetPwd: 'Forgot Password',
            newRegisty: 'Sign Up',
            clearStorageWarn:
                'Account or password incorrect, and 1 login opportunity left，local data will be cleared if error occurs again.',
        },
        search: {
            chatHistory: 'Chat History',
            resultHistory: '{{0}} message(s) related results',
            resultHistoryDetail: '{{0}} message(s) related to {{1}}',
        },
        addFriend: {
            title: 'Add Friends',
            searchTip: 'Phone number/account',
            mobileEmptyTip: 'Please input phone number',
            mobileErrTip: 'The phone nunber is illegal, please input again',
            searchEmpty: 'The account does not exist, please input again',
        },
        friends: {
            title: 'My Friends',
        },
        contactGroup: {
            title: 'My Group',
        },
        contactApprove: {
            title: 'Group Join Request',
        },
        contactList: {
            contactOrg: 'Organization',
            myDept: 'My Department',
            contactStar: 'Star Contacts',
            newFriend: 'New Friends',
            contactFriend: 'My Friends',
            contactGroup: 'My Group',
            contactApprove: 'Group Join Request',
        },
        requestFriend: {
            title: 'New Friends',
            accept: 'Accept',
            sent: 'Sent',
            expired: 'Expired',
            added: 'Added',
        },
        contactStar: {
            title: 'Star Contacts',
        },
        user: {
            editAvatar: 'Avatar',
            removeFriend: 'Delete Friend',
            addFriend: 'Add Friends',
            unsetStar: 'Cancel Star Contact',
            setStar: 'Mark as Star Contact',
            aliasEmpty: 'Set Name',
            removeFriendBefore: 'Delete friend and all associated chats',
        },
        userRequest: {
            editAvatar: 'Change Avatar',
            removeFriend: 'Delete Friend',
            addFriend: 'Add Friend',
            unsetStar: 'Cancel Star Contact',
            setStar: 'Mark as Star Contact',
            aliasEmpty: 'Set Name',
            accept: '通过验证',
            removeFriendBefore:
                'Delete the friend while will delete all chat session.',
            requestInfo: '，请求加你为好友！',
        },
        verifyFriend: {
            title: 'Verificaiton Request',
            tip:
                'He(She) is not your friend, please requested friend verification fristly and then start to chat.',
            iam: 'I am ',
        },
        ack: {
            title: 'Recipient Detail',
            unreadMember: '{{0}} Unread',
            readMember: '{{0}} Read',
        },
        atPanel: {
            everyone: 'All',
        },
        card: {
            selected: '',
            empty: '',
        },
        conversationSetting: {
            title: 'Chat Info',
            mute: 'Mute Notifications',
            top: 'Sticky on Top',
        },
        publicDetail: {
            title: 'Chat Info',
            mute: 'Mute Notifications',
            top: 'Sticky on Top',
            enter: 'Enter the application',
        },
        conversation: {
            setting: 'Chat Info',
            groupSetting: 'Group Info',
            groupNotice: 'Notice',
            history: 'Historical messages',
        },
        forward: {
            forwarded: 'Sent',
            forwardedFailed: 'This message has been recall',
            success: 'Transferred successfully',
        },
        groupSetting: {
            title: 'Group Info',
            groupName: 'Group Name',
            admin: 'Group Owner',
            mute: 'Mute Notifications',
            top: 'Sticky on Top',
            saveContact: 'Save to Contacts',
            joinPermit: 'Join Approval',
            joinPermitMemo:
                'New members need to be approved by group owner to join the group',
            member: 'Group Members',
            banned: 'Mute Settings',
            bannedMemo:
                'When enabled, only group owner and seleced members can chat',
            setting: 'Settings',
            unSetting: 'Not Set',
            dismiss: 'Disband Group',
            groupAlias: 'My Alias in Group',
            groupAliasSetting: 'Set your alias in group',
            quitMemo: 'Are you sure to quit the group?',
            dismissMemo:
                'Group members will lose contacts with other friends after the group dismissed, all chat images, files will also be deleted',
            qrcode: 'Group QR Code',
            onlyOwnerManage: 'Only Group Owner Can Manage',
            onlyOwnerManageMemo:
                "When enabled, other group members can't add members or edit notice",
        },
        groupNotice: {
            title: 'Notice',
            sentTime: 'SentTime',
            empty: 'No notices',
            inputText: 'Enter the content of notice',
            clear: 'Confirm to clear?',
            edit: 'Edit',
            new: 'Post',
            cancel: 'Discard the change?',
            confirm:
                'All members will be notified via @all message in group chat. Post it now?',
            onlyOwnerManage: 'Only group owner can edit notice',
        },
        groupQrcode: {
            tips: 'Scan the QR code to join the group chat ',
        },
        history: {
            title: 'Message Records',
            all: 'All',
            file: 'Files',
            image: 'Images',
            empty: 'No chat record',
        },
        messageInput: {
            emoji: 'Emoji',
            screenshot: 'Screenshot',
            screenshotMaxSize: 'Screenshot to be sent cannot exceed {{0}}',
            sendFile: 'Send File',
            sendCard: 'Contact Card',
            hideWindow: 'Screenshot Without Chat Window',
            zeroSize: 'Can not send a file with a size of 0',
            banned: 'Muting',
            overSize: 'file to be sent cannot exceed {{0}}',
            voiceCall: 'Voice Call',
            videoCall: 'Video Call',
        },
        previewImage: {
            title: 'Send Image',
        },
        forgetPassword: {
            title: 'Password Reset',
        },
        stepPhone: {
            phone: 'Account',
            phoneEmpty: 'Please input phone number',
            phoneInvalid: 'Please input correct phone number!',
            captchaEmpty: 'Please input code',
            captcha: 'Code',
            sendCaptcha: 'Get code',
            sentCaptcha: 'Sent ({{0}})',
            next: 'Next',
        },
        stepPassword: {
            passwordEmpty: 'Please input password',
            confirm: 'Confirm',
            passwordInvalid: 'Please enter 6-16 characters,case sensitive',
            newPassword: 'New',
            tipPwd:
                'Password contain numbers, letters, length 6-16 bits, case sensitive',
            enterNewPwd: 'Confirm',
            newPwdEmpty: 'Please input again',
            newPwdInvalid: 'The two passwords are inconsistent',
        },
        stepSuccess: {
            title: 'Password Reset successful',
        },
        onlineStatus: {
            online: 'Online',
            leave: 'Leave',
            busy: 'Busy',
            offline: 'Offline',
            mobile: 'Mobile online',
        },
        logout: {},
        welcome: {
            title: '',
            motto: 'New Day, New Beautiful Beginning',
            contact: 'Contacts',
            conversation: 'Conversations',
            setup: 'Settings',
            pin: 'PIN',
            work: 'Work',
            sealRTC: 'Seal RTC',
        },
        groupCreate: {
            groupName: 'Group Name',
            tip: '（Not mandatory）',
            createNotice:
                '"Join Approval" enabled. Inviting membership to join this group requires group owner\'s confirmation',
            createSuccess: 'Create successful',
            addMemberSuccess: 'Add successful',
            addMemberPermit: 'Membership invitations have been sent',
            groupNameErr: 'Group name should be more than 2 characters',
            onlyOwnerManageTips: 'Only group owner can add members',
        },
        groupRemovemembers: {
            selectDelTip: 'Select contacts you want to delete',
            delMemberSuccess: 'Delete successful',
            selectNone: 'Select one member at least',
        },
        fileMessage: {
            openFile: 'Open File',
            openFolder: 'Open Folder',
            downloadFile: 'Download',
            cancelled: 'Cancelled',
            cancel: 'Cancel',
            cancelState: 'Cancelled',
            downloadState: 'Downloading',
            receiveState: 'Received',
            sendingState: 'Sending',
            sentState: 'Sent',
            expiredState: 'Expired',
        },
        cardMessage: {
            businessCard: 'Contact Card',
        },
        approvalMessage: {
            content: '{{0}}向你提出了审批',
            pending: '审批中', // Pending
            passed: '审批通过', // Passed
            refused: '审批拒绝', // Refused
            remind: '请及时审批', // Please approve in time
            startTime: 'Start Time',
            endTime: 'End Time',
            title: '审批', // Approval
        },
        quoteMessage: {
            file: 'File',
            link: 'Link',
        },
        unknownMessage: {
            notSupport: "The current version doesn't support for the message",
        },
        setting: {
            title: 'Settings',
            account: 'Account',
            password: 'Password',
            system: 'System',
            about: 'About',
        },
        settingAccount: {
            mobile: 'Phone Number：',
            quitTitle: 'Log Out',
            quitMessage: 'Exit the current account?',
            errorMessage: 'Up to 16 Characters',
            transfiniteMessage: 'Only Supports Chinese,English and Numbers',
        },
        settingSystem: {
            sysMsgNotify: 'System Message Notifications Sound',
            versionInfo: ' Version Information',
            checkUpdate: 'Check Update',
            language: 'Language',
            majorCompany: 'Major Company',
            autoStart: 'Automatically Start {{0}} at Boot',
            previewText: 'Show Preview Text',
            atText: 'You were mentioned by {{0}}',
            notifyText: "You've got a new message.",
            shortcuts: 'shortcuts',
            searchShortcut: 'Search',
            screenshotShortcut: 'Screenshot',
            sendMessageShortcut: 'Send Message',
            sendShortcutWin: 'Enter=send,Shift+Enter=new line',
            sendShortcutMac: 'Return=send,Shift+Return=new line',
        },
        settingAbout: {
            versionInfo: ' Version Information',
        },
        settingPassword: {
            oldPwd: 'Original : ',
            newPwd: 'New : ',
            confirmPwd: 'Confirm : ',
            tipOldPwd: 'Please input original password',
            tipNewPwd: 'Please input new password',
            tipPwdLen: 'Please enter 6-16 characters',
            tipPwd:
                'Password contain numbers, letters, length 6-16 bits, case sensitive',
            tipConfirmPwd: 'Please input again',
            tipMatchPwd: 'The two passwords are inconsistent',
            errorCode: {
                10101: 'Password error!',
            },
        },
        setPassword: {
            safe: 'The account does not exist, please ',
            modify: 'input again',
            newPwd: 'New : ',
            confirmPwd: 'Confirm : ',
            tipNewPwd: 'Please input new password',
            tipPwdLen: '6-16 numbers and letters',
            tipPwd:
                'Password contain numbers, letters, length 6-16 bits, case sensitive',
            tipConfirmPwd: 'Please input again',
            tipMatchPwd: 'The two passwords are inconsistent',
            confirm: 'Confirmed',
        },
        editAvatar: {
            selectPic: 'Select Image',
            getAvatarTokenErr: 'Failed to get token',
        },
        status: {
            netErr: 'Network unavailable, please check your network settings',
        },
        newPin: {
            contact: 'Star',
            addressList: 'Organization',
            friend: 'My Friends',
            selectedContact: 'Selected Member({{0}})',
            content: 'content',
            attaCount: '{{0}} Attachment(s)',
            addAtta: 'Add',
            sendTime: 'Send Time',
            immediatelySend: 'Send Now',
            specificSend: 'Set Send Time',
            sendType: 'Deliver',
            uploading: 'The file is being uploaded....',
            pastTime: 'Can not choose the time of the past',
            sms: 'SMS',
            app: 'App',
            mostReceive:
                'You can choose up to {{0}} people, please delete the staff and try again',
            mostAtta: 'You can only add up to 10 attachments',
            success: 'Send Success',
            mostContent: 'You can only enter up to 5000 words of content',
            year: 'Y',
            month: 'M',
            day: 'D',
            hour: 'H',
            minute: 'M',
            failSend: "Files haven't uploaded completely，so cannot be sent",
        },
        addAttachment: {
            title: 'Add Attachment(s)',
            add: 'Add',
            sendFaild: 'Failed to send',
            uploadFaild: 'Upload failed',
            renewDownload: 'Renew upload',
            resumeUpload: 'Resume upload',
            uploaded: 'Upload success',
            uploading: 'Uploadding',
            cancelled: 'Upload cancelled',
            expired: 'Upload expired',
        },
        addReceiver: {
            selectedContact: 'Selected Member({{0}})',
            selectedPrompt: 'Please select the contact you want to add',
            addSuccess: 'Join Success',
        },
        receivedPin: {
            title: 'Received PIN',
            confirmed: 'Confirmed',
            unConfirmed: 'Unconfirmed',
            reply: 'Replies({{0}})',
            replyNone: 'Reply',
            confirmReceived: 'Confirm receive',
        },
        sendPin: {
            title: 'Sent PIN',
            unConfirmed: '{{0}} Unconfirm',
        },
        pinDetail: {
            title: 'PIN',
            confirmed: 'Confirmed ({{0}})',
            unConfirmed: 'Unconfirmed ({{0}})',
            confirmDetail: 'Confirm Details',
            receiver: 'Recipient(s)',
            input: 'Input reply contents',
            unConfirmedCount: '{{0}} Unconfirm',
            inputCanNotEmpty: 'The input can not be empty',
            allConfirmed: 'All Confirm',
            webRtcTip: 'Please use this function on PC client or mobile client!',
        },
        approve: {
            wait: 'Pass',
            already: 'Passed',
            overdue: 'Expired',
            invalid: 'Failure',
            applyto: 'apply to join ',
            inviter: 'Inviter',
        },
        upgradeSuccess: {
            tips: 'Upgrade success！',
        },
        upgradeFailed: {
            tips: 'Upgrade failed！，please click “Upgrade” and try again！',
        },
        upgradeUpgrading: {
            tips: 'Completed {{0}}%',
        },
        upgradeDetail: {
            version: '{{0}} Version',
            feature: 'New features in this version',
        },
        device: {
            tips: 'Desktop has been locked',
            note:
                "You can unlock it on the status bar at the top of the mobile's session list ",
            button: 'Unlock By Mobile',
            locked: 'Device has been locked',
            earse:
                'Admin has cleared local account information , please log in again.',
        },
        // remoteHangup: {
        //     100: 'Cancelled',
        //     101: 'Declined',
        //     102: 'Disconnected',
        //     103: 'Busy line',
        //     104: 'No answer',
        //     105: '当前引擎暂不支持远程控制',
        //     106: 'Network error',
        //     107: 'Accept by other client',
        //     200: 'Cancelled',
        //     201: 'Declined',
        //     202: 'Disconnected',
        //     203: 'Busy line',
        //     204: 'No answer, please try later',
        //     205: '当前引擎暂不支持远程控制',
        //     206: 'Network error',
        //     300: 'Remote Desktop Connection Fails',
        // },
        collect: {
            all: 'All Favorites',
            text: 'Texts',
            voice: 'Voices',
            position: 'Locations',
            video: 'Photos & Videos',
            file: 'Files',
            link: 'Links',
            collected: 'Added Time',
            second: '"',
            null: 'No Favorites',
            allCollect: 'All',
        },
        public: {
            tips: 'This app has been closed and is temporarily unavailable',
        },
        syncdataLoading: {
            failed: 'Data update error. Please try again.',
            completed: 'Completed',
            process: 'Please Wait for Data Updates',
        },
        voipInvitemember: {
            selectedMember: 'Selected Member({{0}})',
            audioMaxWarn:
                'Voice call supports up to {{0}} people, while others join as observers.',
            videoMaxWarn:
                'Video call supports up to {{0}} people, while others join as observers.',
        },
        sealRTC: {
            title: '发起一个会议',
            subject: '会议主题',
            id: '会议室ID',
            startTime: '开始时间',
            inviteUsers: '邀请参会人员',
            invitedUsers: '已邀请({{0}})人',
            sendMessage: '发送邀请消息',
            directJoin: '直接加入',
            sendButton: '发送邀请信息',
            directJoinButton: '会议已存在,直接加入',
            clickLink: '，点击链接可直接参会。',
            pinTitle: 'PIN的内容：邀请您参加线上会议',
            subjectPlaceholder: '请输入会议名称',
            idPlaceholder: '请输入会议ID',
            metting: '的会议',
            subjectRule: '请输入1到30位的字符',
            rtcRule: '请输入1到30位的数字，字母 -的组合',
            now: '现在',
            mostReceive: '最多可选择 {{0}} 人，请删减人员后重试',
        },
    },
    errorCode: {
        'logout-by-otherclient': 'You have logged out of PC',
        'kicked-offline-by-otherclient': 'kicked offline by other client',
        'user-be-blocked': 'The user is blocked',
        'user-status-updated': 'Welcome to xxx, please login again',
        'unknown-error': 'Unknown error',

        'old-password-error': 'Password error!',
        'new-password-same-old-password':
            'The new password should not consistent with the current one，please try again.',
        'password-changed': 'Password changed, please login again!',
        'account-changed': 'The account has been modified. Please log in again',
        'password-overtime': 'Password has expired.',

        'message-recall-timeout':
            'Recall failed , sent message more than 3 minutes！',

        'network-error': 'Network error',
        'request-data-failed': 'Network error, data acquisition failure',
        'request-failed': 'Request failed!',

        'invalid-config': 'Failed to get appkey or server from config.js',
        'invalid-token': 'Invalid token',
        'require-captcha': 'Please get code firstly',

        'card-limit': 'Only one card can be sent at a time',

        'forward-limit': 'Forward maximum limit 10 chats',

        'download-interrupted': 'Download interrupted',
        'download-cancelled': 'Download cancelled',
        'download-error': 'Download error',
        'download-ebusy': 'File occupied by other program',
        'download-eperm': 'Write file not permission',

        'upload-error': 'Upload error',
        'upload-timeout': 'Upload timeout',

        'file-404': 'Local file does not exist or has been deleted',
        'file-error': 'Local file load error',

        'status-1': 'Connecting...',
        'status-2': 'Connection disconnected',
        'status-3': 'Network unavailable',
        'status-4': 'Connection closed',
        'status-6': 'The account logged on other devices',
        'status-12': 'The domain name is incorrect',
        'status-13': 'The user is blocked',

        'contact-1': 'Select one member at least',
        'contact-2': 'Create successful',
        'contact-3': 'Delete successful',
        'contact-4': 'Add successful',
        'contact-5': 'Quit successful',
        'contact-6': 'Disband successful',

        'lib--1': 'Request Timeout',
        'lib--2': 'Unknown error',
        'lib-7': 'Network unavailable',
        'lib-20604': 'Too fast',
        'lib-22406': 'You are not in this group',
        'lib-21501': 'message is intercept by sensitive words',
        'lib-21502': 'message is replaced by sensitive words',

        10001: 'Insufficient permissions',
        10002: 'Non-support',
        10004: 'Unrealized function',
        10005: 'Server unusual',
        10006: 'Invalid request parameters',
        10009: 'Sent too more times, please try later!',
        15001: 'Sent too more times, please try later!',

        '10101-4': 'Account or password incorrect, please input again',
        '10101-3': 'Account or password incorrect, and 3 login chances left',
        '10101-2': 'Account or password incorrect, and 2 login chances left',
        '10101-1': 'Account or password incorrect, and 1 login chance left',

        10100: "The account doesn't exist, please input again",
        10101: 'Account or password incorrect, please input again',
        10102: 'User no logged in or user status expired',
        10103: 'Incorrect password format',
        10104: 'Nickname cannot be empty',
        10105: 'Nickname exceeds maximum length',
        10106: 'Avatar URL cannot be empty',
        10107: 'Avatar URL exceeds maximum length',
        10108: 'User no logged in or user status expired',
        10109: 'User name is empty',
        10110: 'Password is empty',
        10111: 'Account disabled',
        10112: 'Get Token failed',
        10113: 'User ID cannot be empty',
        10114: 'Password cannot be empty',
        10115: 'Invalid phone number',
        10116: 'Send code too fast',
        10117: 'Verification code has expired',
        10118: 'Please send code firstly',
        10119: 'Please verify code firstly',
        10120: 'Verification code error',
        10121: 'User already exist',
        10122: 'Logon token timeout',
        10123: 'Login token invalid',
        10126: 'Original password error',
        10128: 'Account or password multiple errors, please try again {{0}} later or retrieve your password',
        10130: 'User mobile existed',

        10200: 'Requested department does not exist',
        10201: 'Department name cannot be empty',
        10202: 'Invalid department ID',
        10203: 'No found superior department',
        10204: 'Creator ID is illegal',
        10205: 'No found creator ID',
        10206: 'Invalid ManagerID',
        10207: 'No found Manager',
        10208: 'Invalid department member ID',
        10209: 'Department member is empty',
        102010: 'Existed department ID',

        // '10400': 'Sort Types not supported',
        // can not add yourself
        10400: 'You cannot add yourself as friend',
        // request not exist
        10401: 'Target contact does not exist',
        // friend not found
        10402: 'Friend does not exist',
        // request is timeout
        10403: 'Request Timeout',
        // friendship is created
        10404: 'Friendship is created',

        10500: 'Unknown employee',
        10501: 'Employee name cannot be empty',
        10502: 'Employee name already exist',
        10503: 'Employee mailbox cannot be empty',
        10504: 'Employee mailbox already exists',
        10505: 'Invalid employee ID',
        10506: 'Employee ID already exists',
        10507: 'Administrator does not exist',
        10508: 'Please input phone number',
        10509: 'Phone number already exists',

        10600: 'Requested group does not exist',
        10601: 'Group name cannot be empty',
        10602: 'Group name length exceeds limit',
        10603: 'Member number exceeds the limit',
        10604: 'Group number which user created exceeds the limit',
        10605: 'Requested group member does not exist',
        10606: 'Group member already exist',
        10607: 'Invalid group ID',
        10608: 'Invalid group member ID',
        10609: 'No found corresponding department',
        10610: 'Invalid corresponding department ID',
        10611: 'Lack of group type',
        10612: 'Group ID already exists',
        10613: 'Official group already exists',
        10614: 'Company does not exist',
        10615: 'Invalid company ID',
        10626: 'Only group owner can add members',
        10645: 'Group Members up to {{0}} People',

        10700: 'No found company',
        10701: 'Invalid company ID',
        10702: 'Company ID already exists',
        10703: 'Empty company name',
        10704: 'Empty company full name',
        10705: 'Empty group name',
        10706: 'Official group exists',
        10707: 'No official group',

        10800: 'Invalid collection group ID',
        10801: 'No found corresponding group',
        10802: 'Collection group does not exist',

        10900: 'No found corresponding contact',
        10901: 'Collection contact does not exist',

        11000: 'No found scope',
        11001: 'No found name',

        12000: 'Invalid topic',

        13000: 'No found position information',

        11400: 'not in receiver list',
        11401: 'not the creator of the pin',
        11402: 'not confirmed',
        11403: 'pin has been deleted',
        11404: 'pin has been sent',
        11405: 'pin still not send',
        11410: 'pin param is invalid',
        12302: 'Device has been locked',
    },
};
